<template>
  <section>
    <div class="pt-3">
      <strong>{{ $t('message.my_listings.add_pet_types') }}</strong>
      <a href="" @click.prevent="showModal = true" class="text-info"><i class="fal fa-exclamation-square fa-lg"></i></a>
    </div>
    <b-modal v-model="showModal">
      <div slot="modal-title">{{ $t('message.my_listings.pet_recommendation_title') }}</div>
      <div class="text-center">
        <img src="/static//img/puppy-svgrepo-com.svg" withd="128"/>
      </div>
      <div class="bg-light rounded p-2 mt-3">
        {{ $t('message.my_listings.pet_recommendation01') }}
      </div>
      <div class="bg-light rounded p-2 mt-3">
        {{ $t('message.my_listings.pet_recommendation02') }}
      </div>
      <div slot="modal-footer" class="w-100">
        <b-btn class="float-right" variant="secondary" @click="showModal = false">
          {{ $t('message.button.close') }}
        </b-btn>
      </div>
    </b-modal>
  </section>
</template>

<script>
  export default {
    data () {
      return {
        showModal: false
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/booking/components/PetSelectionLabel.vue